export enum PURCHASE_STATES {
  CREATED = 'CREATED',
  INCOMPLETE = 'INCOMPLETE',
  COMPLETED = 'COMPLETED',
}
